import React from "react";

interface Props {
  condition: boolean;
  wrap: (children: React.ReactNode) => React.ReactElement;

  children?: any;
}

function ConditionalWrap({ condition, wrap, children }: Props) {
  if (condition) {
    return wrap(children);
  }
  return children;
}

export default ConditionalWrap;
